import React from 'react'
import Box from '../primitives/Box'
import lineImage from '../../assets/images/podcast/line.svg'

export function SquigglyLine() {
  return (
    <Box
      width="100%"
      height={6}
      css={`
        background-image: url(${lineImage});
        background-repeat: repeat-x;
        background-size: auto 6px;
      `}
    />
  )
}
